export const DeezerCard = ({ url, meta, postId }) => {
  // Extract Deezer content type and ID for embed
  // Formats: https://www.deezer.com/track/123, /album/123, /playlist/123
  const match = url.match(/deezer\.com\/(track|album|playlist)\/(\d+)/);

  if (match) {
    const [, type, id] = match;
    return (
      <div className="mt-3 rounded-2xl overflow-hidden w-full max-w-full" data-testid={`deezer-card-${postId}`}>
        <iframe
          src={`https://widget.deezer.com/widget/dark/${type}/${id}`}
          width="100%"
          height={type === "track" ? "130" : "300"}
          frameBorder="0"
          allow="encrypted-media; clipboard-write"
          loading="lazy"
          className="rounded-2xl"
          title="Deezer"
          style={{ maxWidth: "100%" }}
        />
      </div>
    );
  }

  // Fallback: show card with meta info but no external link
  if (meta && meta.thumbnail_url) {
    return (
      <div className="mt-3 flex items-center gap-3 bg-[#A238FF]/10 border border-[#A238FF]/30 rounded-2xl p-3 w-full max-w-full" data-testid={`deezer-card-${postId}`}>
        <img src={meta.thumbnail_url} alt="" className="w-12 h-12 sm:w-16 sm:h-16 rounded-xl object-cover shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground truncate">{meta.title}</p>
          <p className="text-xs text-muted-foreground mt-0.5">Deezer</p>
        </div>
      </div>
    );
  }
  return null;
};
